<template>
    <div class="wrap-content-btn-expand">
        <div v-if="isCustomHeader" @click="toggleExpand">
            <slot name="custom-header"></slot>
        </div>
        <div class="btn-expand d-flex-between-center" @click="toggleExpand" v-if="!isCustomHeader">
            <div class="">
                <slot name="header-content"></slot>
            </div>
            <div :class="{ rotate_icon_180: isExpand, rotate_icon_0: !isExpand }">
                <SOIconBase view-box="0 0 16 16" width="20" height="20">
                    <template v-slot:icon>
                        <ChevronRight1616 />
                    </template>
                </SOIconBase>
            </div>
        </div>
        <div
            class="content"
            :id="`${id}-content`"
            v-if="isHasExpand"
            :class="{ show: isExpand, 'm-t-16': isExpand && !isCustomHeader }"
        >
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import ChevronRight1616 from "@/so-components/global/icons/iconPacks/ChevronRight1616.vue";

export default {
    name: "SODetailExpand",
    props: {
        id: {
            type: String,
            required: true,
        },
        fullHeight: {
            type: Number || String,
        },
        expanded: {
            type: Boolean,
            defualt: false,
        },
        disableToggleExpand: {
            type: Boolean,
            defualt: false,
        },
    },
    components: {
        SOIconBase,
        ChevronRight1616,
    },
    data() {
        return {
            isExpand: false,
        };
    },
    mounted() {
        this.setExpand(this.expanded);
    },
    watch: {
        isExpand: function(newVal, oldVal) {
            let elHeight = this.fullHeight ? `${this.fullHeight}px` : `100%`;
            elHeight = newVal ? elHeight : "0px";

            document.getElementById(`${this.id}-content`).style.height = elHeight;
            if (newVal !== oldVal) {
                setTimeout(
                    () => {
                        this.setVisible();
                    },
                    newVal ? 200 : 0
                );
            }
        },
        expanded: function(nE, oE) {
            if (nE !== oE) {
                this.setExpand(nE);
            }
        },
    },
    computed: {
        isHasExpand() {
            return !!this.$slots.content;
        },
        isCustomHeader() {
            return !!this.$slots["custom-header"];
        },
    },
    methods: {
        setExpand(val) {
            this.isExpand = val;
        },
        toggleExpand() {
            if (!this.disableToggleExpand) {
                this.isExpand = !this.isExpand;
            }
        },
        setVisible() {
            let content = document.getElementById(`${this.id}-content`);
            let elHeight = this.fullHeight ? `${this.fullHeight}px` : `100%`;
            if (elHeight === content.style.height) {
                document.getElementById(`${this.id}-content`).style.overflow = "hidden";
                document.getElementById(`${this.id}-content`).style.overflowY = "scroll";
            } else {
                document.getElementById(`${this.id}-content`).style.overflow = "hidden";
            }
        },
    },
};
</script>
<style scoped>
.wrap-content-btn-expand {
    position: relative;
}

.wrap-content-btn-expand .position_mid {
    text-align: center;
}

.wrap-content-btn-expand .rotate_icon_180 {
    transform: rotate(270deg);
    transition-duration: 300ms;
}

.wrap-content-btn-expand .rotate_icon_0 {
    transform: rotate(90deg);
    transition-duration: 300ms;
}
.wrap-content-btn-expand .content {
    height: 0px;
    transition: height 0.2s ease-out;
    overflow: hidden;
}
.wrap-content-btn-expand .content.show {
    transition: height 0.2s ease-in;
    overflow: hidden;
    overflow-y: scroll;
}
</style>
